import axiosSecure from '@api/axiosSecure';
import getContextRoot from '@api/getContextRoot';

export interface Opt {
  name?: string;
  region?: string;
  subRegion?: string;
  wines?: { id: number };
  country?: string;
  usState?: string;
  additionalInformation?: string;
}

const addLocation = async (opt: Opt): Promise<any> => {
  const res = await axiosSecure.post(`${getContextRoot()}/location`, opt);
  return res.data;
};

export default addLocation;
